import React from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import HeaderSection from "../components/head-section-two";
const Person = () =>{
    return (
        <div id="item_img">
        <img src={"https://www.investnational.com.au/wp-content/uploads/2016/08/person-stock-2.png"} alt=""/>
        <hr id="line_grid_3_system_img"/>
        <p id="item_img_title">Hirwa Aldo</p>
        <p id="item_img_price">Web Development</p>
        </div>
    )
}
const Carreer = () =>{
    document.body.style.backgroundColor = "white"
    return (
        <div>
            <Header />
               <HeaderSection 
               title="Carreer" 
               smallTitle="Smart Shopper Members /" 
               usmallTitle="4"
               />
               <section id="section_shop">
               <div id="grid_4_cart">
                        {
                            [1,2,34,5].map((v,k)=>{
                                return <Person />
                            })
                        }
                    </div> 
               </section>
            <Footer />
        </div>
    )
}
export default Carreer;
